// Simple horizontal carousel for the blog's featured collection

document.addEventListener('DOMContentLoaded', () => {
  const tracks = document.querySelectorAll('[data-afc-track]');
  if (!tracks.length) return;

  tracks.forEach((track) => {
    const wrapper = track.closest('.article-featured-collection__wrapper');
    if (!wrapper) return;

    const prevBtn = wrapper.querySelector('.afc-btn--prev');
    const nextBtn = wrapper.querySelector('.afc-btn--next');
    if (!prevBtn || !nextBtn) return;

    const firstItem = track.querySelector('.article-featured-collection__item');
    if (!firstItem) return;

    // How far to scroll each click (one card width + gap)
    const getStep = () => {
      const rect = firstItem.getBoundingClientRect();
      return rect.width + 24; // 24px ≈ our 1.5rem gap
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });
});
